// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gRfo4lVy0IrIHMMl8Amq{color:var(--content-primary-secondary);padding:24px 12px 14px}.E_AiTcQOEowRgXkqyGU0{color:var(--content-primary-tertiary);text-align:center;padding:17.5px 0}.tVeTNnyNR4FfmzaU8Kke{padding:16px 0 20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `gRfo4lVy0IrIHMMl8Amq`,
	"notResult": `E_AiTcQOEowRgXkqyGU0`,
	"linkWrap": `tVeTNnyNR4FfmzaU8Kke`
};
export default ___CSS_LOADER_EXPORT___;
